import { render, staticRenderFns } from "./PartnerNoticeFormRegistrationPopup.vue?vue&type=template&id=e1cf48ba&"
import script from "./PartnerNoticeFormRegistrationPopup.vue?vue&type=script&lang=ts&"
export * from "./PartnerNoticeFormRegistrationPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports